import { z } from 'zod';

import { captureSentryException } from 'shared/utils';

import { VERIFY_EMAIL_FEATURE_TAG, VERIFY_EMAIL_SERVER_FIELDS, VERIFY_EMAIL_VALIDATION_ERROR_CODES } from '../consts';

const VerifyEmailServerErrorPayloadSchema = z.object({
  fields: z.record(z.nativeEnum(VERIFY_EMAIL_SERVER_FIELDS), z.array(z.nativeEnum(VERIFY_EMAIL_VALIDATION_ERROR_CODES)))
});

/** Extracts field errors from the verify-email API 400 payload (`{ code, fields }`) into a flat array. */
export const mapVerifyEmailServerErrorsToFieldErrors = (error: unknown) => {
  const result = VerifyEmailServerErrorPayloadSchema.safeParse(error);

  if (!result.success) {
    captureSentryException({
      message: 'Unrecognised verify-email validation error',
      feature: VERIFY_EMAIL_FEATURE_TAG,
      error,
      extra: { method: 'mapVerifyEmailServerErrorsToFieldErrors', zodErrors: result.error.flatten() }
    });

    return [];
  }

  const { fields } = result.data;
  const fieldValues = Object.values(VERIFY_EMAIL_SERVER_FIELDS);

  return fieldValues.flatMap((field) => (fields[field] ?? []).map((code) => ({ field, code })));
};
